import CustomerOrderStatusBadge from '#/modules/crmMgmt/customerOrder/components/CustomerOrderStatusBadge';
import { formatDocumentCurrencyLabel } from '#/utils/documentCurrencyLabel';
import { formatDateOrDash } from '#/utils/date';
import { formatDisplayAmount } from '#/utils/formatNumber';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function formatListDate(value) {
  if (value == null || value === '') {
    return '-';
  }
  return formatDateOrDash(String(value).trim().slice(0, 10));
}

function formatCustomerLabel(row) {
  const customer = row?.customer;
  if (!customer) {
    return '-';
  }
  const label = [customer.code, customer.name].filter(Boolean).join(' - ');
  return label || '-';
}

/** Block A：僅狀態 */
export const customerOrderSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {row?.status
            ? <CustomerOrderStatusBadge status={row.status} size="sm" />
            : <p>-</p>}
        </div>
      ),
    },
  ],
};

/** Block C：其餘欄位（唯讀；無簽核） */
export const customerOrderSideMsgDetailBlock = {
  fields: [
    { label: '客戶訂單號', value: 'customerOrderNo' },
    { label: '客戶', value: formatCustomerLabel },
    {
      label: '訂單日',
      value: (row) => formatDateOrDash(row?.customerOrderDate),
    },
    { label: '幣別', value: (row) => formatDocumentCurrencyLabel(row) },
    // Search 可不回金額；缺則 format 為 —
    { label: '總額', value: (row) => formatDisplayAmount(row?.totalAmount) },
    {
      label: '明細數',
      value: (row) => dash(row?.lineCount),
    },
    {
      label: '銷貨單數',
      value: (row) => dash(row?.salesOrderCount),
    },
    {
      label: '建立日',
      value: (row) => formatListDate(row?.record?.createdAt),
    },
    { label: '備註', value: (row) => dash(row?.remark) },
  ],
};

export const customerOrderSideMsgBlocks = [
  customerOrderSideMsgStatusBlock,
  customerOrderSideMsgDetailBlock,
];
